import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
// RBAC 2.0.0 promoted the new-frontend-system plugin from `/alpha` to the main
// entry point; the legacy plugin moved to `/legacy`.
import rbacPlugin from '@backstage-community/plugin-rbac';
import { navModule } from './modules/nav';
import { scmAuthModule } from './modules/scmAuth';
import { appModule } from './modules/app';
import { coderPlugin } from './modules/coder';
import {kubernetesModule} from "./modules/kubernetes";
import {jfrogArtifactoryPlugin} from "./modules/jfrogArtifactory";
import {explorePlugin} from "./modules/explore";
import {entityValidationModule} from "./modules/entityValidation";
import {fluxModule} from "./modules/flux";
import { themeModule } from '@ipen/backstage-theme';
import techDocsAddonsModule from '@ipen/backstage-plugin-techdocs-addons';
import { scaffolderModuleIpen } from '@ipen-portal/plugin-scaffolder-module-ipen';
import apiDocsModuleCrd from '@terasky/backstage-plugin-api-docs-module-crd';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    scmAuthModule,
    appModule,
    themeModule,
    techDocsAddonsModule,
    coderPlugin,
    kubernetesModule,
    jfrogArtifactoryPlugin,
    explorePlugin,
    entityValidationModule,
    rbacPlugin,
    fluxModule,
    scaffolderModuleIpen,
    apiDocsModuleCrd],
});
